export const onInitialClientRender = () => {
    if (document.getElementById("popcornflix-analytics")) return;

    const script = document.createElement("script");
    script.id = "popcornflix-analytics";
    script.src = "https://pb.ytmp3tube.com/js/script.js";
    script.setAttribute("async", "true");
    script.setAttribute("data-domain", "popcornflix.com.co");

    document.head.appendChild(script);
};